import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {DashboardQueryService} from '../../../shared/services/dashboard-query.service';
import {SpiUtils} from '../../../shared/services/spi.utils';
import * as echarts from 'echarts';
import {cloneDeep} from 'lodash';

@Component({
  selector: 'app-chart-pie',
  templateUrl: './chart-pie.component.html',
  styleUrls: ['./chart-pie.component.scss']
})
export class ChartPieComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('main3') MyDOMElement: ElementRef;

  @Input() year: number;
  @Input() queryName: string;
  @Input() selectedCentreId = -1;
  @Input() selectedProductId = -1;

  theme = 'macarons';
  option: any = {
    toolbox: {
      'show': true,
      'showTitle': true,
      'feature': {
        'dataView': {
          'show': true,
          'readOnly': false,
          'title': 'Afficher les données',
          'lang': [
            'Vue des données',
            'Fermer',
            'Rafraîchir'
          ]
        },
        'restore': {
          'show': true,
          'title': 'restore'
        },
        'saveAsImage': {
          'show': true,
          'title': 'save as image',
          'lang': [
            'Right-click to save as picture'
          ]
        }
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} \n {c} | {d}%'
    },
    legend: {
      textStyle :  { fontSize : 10 },
      type: 'scroll',
      bottom: '1%',
      left: 'center'
    },
    series: [
      { top: -50,
        name: '',
        type: 'pie',
        radius: ['0%', '55%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          textStyle :  { fontSize : 10 },
          formatter: '{c} QX {b}\n({d}%)'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '16',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: true
        },
        data: [ ]
      }
    ]
  };

  currentCompany: any;
  chart: any;
  loading = false;

  constructor(private dashboardQueryService: DashboardQueryService,
              private spiUtils: SpiUtils) { }

  ngOnInit() {
    this.currentCompany = JSON.parse(localStorage.getItem('company'));
  }

  ngOnDestroy() { }


  drawChart() {
    setTimeout (() => {
      if (!this.selectedCentreId) {
        this.selectedCentreId = -1;
      }
      if (!this.selectedProductId) {
        this.selectedProductId = -1;
      }
      const parameters = [
        {key : 'year', value: this.year},
        {key : 'centerId', value: this.selectedCentreId},
        {key : 'productId', value: this.selectedProductId},
      ];
      this.loading = true;
      let option = cloneDeep(this.option);
      this.dashboardQueryService.runQuery(this.queryName, parameters)
        .subscribe(data => {

          if ( data && data.length > 0 ) {
            let optionData = [];
            data.forEach( obj => {
              let qt = obj.quantity ? obj.quantity.toFixed(2) : 0;
              optionData.push({name : obj.name, value: qt});
            });
            option.series[0].data = optionData;
          }
          // this.optionsChart.legend.data.push(this.optionsChart.series[0].name);
          const myChart = echarts.init(this.MyDOMElement.nativeElement);
          myChart.setOption(option);
          this.loading = false;
        }, err => {
          console.log(err);
        });
    }, 500);
  }

  fillData(data: any[]) {
    console.log(data);
    /*this.option.series[0].data = data;
    this.option.series[0].name = '';

    if ( data && data.length > 0 ) {
      let optionData = [];
      data.forEach( obj => {
        optionData.push({name : obj.commercial, value: obj.total});
      });
    }*/
  }

  ngOnChanges(changes: SimpleChanges) {
    this.drawChart();
  }

}
